// extracted by mini-css-extract-plugin
export default {"title":"TimesheetDownloadSuccessModal_title__SvdVI","subtitle":"TimesheetDownloadSuccessModal_subtitle__J-Jpg"};